export default "__VITE_ASSET__D3tu96fB__"